var $0913a66d7c610208$exports = {};
$0913a66d7c610208$exports = {
    "valid": `\u{635}\u{627}\u{644}\u{62D}`
};


export {$0913a66d7c610208$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
